$(document).ready(function(){

	$(document).on('click', '.menu-category', function() {
		window.location = $(this).attr('href');
	});

    // window.onload = function () {
    //     $('.preloader-wrapper').fadeOut(500, function(){
    //         $('.preloader-wrapper').remove();
    //     });
    // }

	$('.select2').select2();

	/* A function that toggles the class active on the button and changes the type of the input field to
	text or password. */
	$(".btn-password").on("click", function(e)
	{
		$(this).toggleClass('active');
		if ( $(this).hasClass('active') )
		{
			$(this).siblings('.form-control').attr("type","text");
		} else
		{
			$(this).siblings('.form-control').attr("type","password");
		}
	});

    $(".btn-submenu").on("click", function(e)
	{
		e.preventDefault();
		let submenu = $(this).siblings('.submenu');
		submenu.slideToggle();
	});

	/* A jQuery function that is toggling the class active on the element with the class submenu-btn. */
	// $('.side-menu-link').on('mouseenter', function() {
	// 	$(this).siblings('.submenu-btn').toggleClass('active');
	// 	$(this).siblings('.drop-list').slideToggle();
    // });
	// $('.side-menu-link').on('mouseleave', function() {
	// 	$(this).siblings('.submenu-btn').toggleClass('active');
	// 	$(this).siblings('.drop-list').slideToggle();
	// });
	$(".side-menu-link").on('click', function(e) {
		e.preventDefault();
		$(this).siblings('.submenu-btn').toggleClass('active2');
		$(this).siblings('.drop-list').slideToggle();
	});
	// $(".submenu-btn").on('click', function(e) {
	// 	e.preventDefault();
	// 	$(this).toggleClass('active');
	// 	$(this).siblings('.drop-list').slideToggle();
	// });
	$(".filter-show-dropdown").on('click', function(e) {
		e.preventDefault();
		$(this).toggleClass('active');
		$(this).siblings('.submenu-btn').toggleClass('active2');
		$(this).siblings('.drop-list').slideToggle();
	});

	/* A function that is initializing the Perfect Scrollbar library. */
	if ( $('.scroll-box').length > 0 )
	{
		const ps = new
			PerfectScrollbar('.scroll-box', {
			wheelSpeed: 2,
			// wheelPropagation: true,
			minScrollbarLength: 20,
			// maxScrollbarLength: 63,
			useBothWheelAxes: true
		});
	}


	/* A function that is toggling the class active on the element with the class submenu-btn. */
	const button = document.querySelector('.card.template-menu .card-link');
	if(button) {
		const hiddenItems = document.querySelectorAll('.card.template-menu .card-menu--item.d-none');
		const cardMenu = document.querySelectorAll('.card.template-menu');
		let isHidden = true;
		button.addEventListener('click', (e) => {
			e.preventDefault();
			button.textContent = isHidden
			? 'Vezi mai putine'
			: 'Vezi mai multe';

			isHidden = !isHidden;
			console.log(cardMenu);
			hiddenItems.forEach(item => item.classList.toggle('d-none'));
			$(cardMenu).toggleClass('opened');
		});
	}

	/* This is a datepicker. */
	// locale setup
	const localeEn = {
		days: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
		daysShort: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
		daysMin: ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'],
		months: ['January','February','March','April','May','June', 'July','August','September','October','November','December'],
		monthsShort: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
		today: 'Today',
		clear: 'Clear',
		dateFormat: 'dd/MM/yyyy',
		timeFormat: 'hh:ii aa',
		firstDay: 1
	}
	// creating date picker with locale
	new AirDatepicker('.input-date', {
		locale: localeEn,
		dateFormat: 'dd-MM-yyyy'
	})


	const counters = document.querySelectorAll('.counter-value');
	const speed = 200;

	counters.forEach( counter => {
		const animate = () => {
			const value = +counter.getAttribute('counter');
			const data = +counter.innerText;

			const time = value / speed;
			if(data < value) {
				counter.innerText = Math.ceil(data + time);
				setTimeout(animate, 1);
				}else{
				counter.innerText = value;
				}

		}

		animate();
	});

	/* A function that is initializing the AOS library. */
	AOS.init();

    // Example starter JavaScript for disabling form submissions if there are invalid fields
	(() => {
		'use strict'

		// Fetch all the forms we want to apply custom Bootstrap validation styles to
		const forms = document.querySelectorAll('.needs-validation')

		// Loop over them and prevent submission
		Array.from(forms).forEach(form => {
		form.addEventListener('submit', event => {
			if (!form.checkValidity()) {
			event.preventDefault()
			event.stopPropagation()
			}

			form.classList.add('was-validated')
		}, false)
		})
	})()
	// Check screen width
	var screenWidth = window.screen.width;
	ratioPlayer = null;
	if (screenWidth > 768) 
	{
		ratioPlayer = '7:3';
	}
	
	if ( $('.player-hero').length > 0 ) {
		var playerHero;
		$('.player-hero').each(function(index, item) {
			playerHero = new Plyr('#player-hero-'+$(item).data('mid'), {
				controls: ['play', 'mute'],
				ratio: ratioPlayer
			});
		});
	}

	// JavaScript to handle the parallax scrolling effect on the text
	// document.addEventListener('scroll', function () {
	// 	const scrollPosition = window.pageYOffset;
	// 	const parallaxElements = document.querySelectorAll('.parallax-text');

	// 	parallaxElements.forEach(element => {
	// 		const speed = element.getAttribute('data-speed');
	// 		element.style.transform = 'translateY(calc(-50% - ' + (scrollPosition * 0.1) + 'px))';
	// 	});
	// });

	// const parallaxElements = document.querySelectorAll('.parallax-text');

    // // Create an Intersection Observer
    // const observer = new IntersectionObserver((entries) => {
    //     entries.forEach(entry => {
    //         if (entry.isIntersecting) {
    //             entry.target.style.opacity = 1; // Make text visible when it comes into view
    //             entry.target.classList.add('in-view');
    //         } else {
    //             entry.target.style.opacity = 0; // Hide text when it leaves view
    //             entry.target.classList.remove('in-view');
    //         }
    //     });
    // }, {
    //     threshold: 0.1 // Adjust this value as needed
    // });

    // // Observe each parallax element
    // parallaxElements.forEach(element => {
    //     observer.observe(element);
    // });

    // // Handle the parallax effect on scroll
    // document.addEventListener('scroll', () => {
    //     const scrollPosition = window.pageYOffset;

    //     parallaxElements.forEach(element => {
    //         if (element.classList.contains('in-view')) { // Only move the element if it's in view
    //             const speed = element.getAttribute('data-speed');
    //             const parentOffset = element.closest('.template-banner--hero').offsetTop;
    //             const relativeScroll = scrollPosition - parentOffset;
    //             element.style.transform = `translateY(calc(-50% - ${relativeScroll * 0.1}px))`;
	// 			// element.style.transform = 'translateY(calc(-50% - ' + (scrollPosition * 0.1) + 'px))';
    //         }
    //     });
    // });

	// var triggerElTab = document.querySelector('.menu-category')
	// bootstrap.Tab.getInstance(triggerElTab).show() // Select tab by name
	
	// $(triggerElTab).on('hove', function(e) {
	// 	// e.preventDefault();
	// 	console.log('works');
	// 	$(this).toggleClass('active');
	// 	// $(this).siblings('.drop-list').slideToggle();
	// });
	document.querySelectorAll('#menu-category-tab .nav-link').forEach(function(everyitem){ 	
	
		var tabTrigger = new bootstrap.Tab(everyitem)
		everyitem.addEventListener('mouseenter', function(){
			tabTrigger.show();
		});
		
	});
});



// WEBPACK FOOTER //
// ./resources/assets/js/regular/general.js